'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  SEO_QUERY
} from "./chunk-W3K3QG4J.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/events/artists.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getEventArtists($lang: String, $skip: Int, $where: EventFilter, $order: [EventOrder]) {
  eventCollection(locale: $lang, limit: 1, skip: $skip, where: $where, order: $order) {
    items {
      id
      slug
      title
      artistsCollection(limit: 100) {
        items {
          name
          subtitle
          thumbnail {${IMAGE_QUERY}}
        }
      }
      seo{${SEO_QUERY}}
    }
  }
}
`;
var getEventArtists = (props) => __async(void 0, null, function* () {
  var _a;
  try {
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: "order_ASC"
    }, props), {
      lang: getContentfulSafeLocale(props.lang)
    }));
    return ((_a = res.eventCollection.items) == null ? void 0 : _a[0]) || null;
  } catch (error) {
    throw new Exception({ error, name: "getEventArtistsException" });
  }
});
var useGetEventArtists = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getEventArtists", props],
    queryFn: () => getEventArtists(props)
  }));
};

export {
  getEventArtists,
  useGetEventArtists
};
//# sourceMappingURL=chunk-KONEYT3L.mjs.map